<nz-spin [nzSpinning]="loading$ | async">
  <form
    nz-form
    class="form"
    nzLayout="horizontal"
    [formGroup]="materialForm"
    (ngSubmit)="onSave($event)">
    <div class="drawer-form-wrapper">
      <nz-form-item>
        <nz-form-label nzRequired nzFor="name">Name</nz-form-label>
        <nz-form-control [nzErrorTip]="nameErrorTpl">
          <input
            nz-input
            id="name"
            formControlName="name"
            placeholder="Enter name" />
          <ng-template #nameErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')"
              >Please input name</ng-container
            >
            <ng-container *ngIf="control.hasError('minlength')">
              Name must be at least {{ MIN_NAME_LENGTH }} characters
            </ng-container>
            <ng-container *ngIf="control.hasError('maxlength')">
              Name must be less than {{ MAX_NAME_LENGTH }} characters
            </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired nzFor="description"
          >Description</nz-form-label
        >
        <nz-form-control [nzErrorTip]="descriptionErrorTpl">
          <textarea
            nz-input
            id="description"
            formControlName="description"
            rows="4"
            placeholder="Enter description"></textarea>
          <div class="mt-3 remaining-text">
            {{
              materialForm.value.description
                ? materialForm.value.description.length
                : 0
            }}
            of 500 characters used
          </div>
          <ng-template #descriptionErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')"
              >Please input description</ng-container
            >
            <ng-container *ngIf="control.hasError('minlength')">
              Description must be at least
              {{ MIN_DESCRIPTION_LENGTH }} characters
            </ng-container>
            <ng-container *ngIf="control.hasError('maxlength')">
              Description must be at most
              {{ MAX_DESCRIPTION_LENGTH }} characters
            </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-control>
          <nz-upload
            [nzFileList]="fileList"
            [nzBeforeUpload]="beforeUpload"
            [nzRemove]="handleRemove"
            [nzIconRender]="iconTemplate"
            nzListType="picture"
            [nzShowUploadList]="{
              showRemoveIcon: true,
              showPreviewIcon: true,
              showDownloadIcon: false,
            }"
            nzDrop
            [nzMultiple]="false"
            class="file-upload"
            [nzAccept]="allowedFileExtensions">
            <button nz-button type="button">
              <div class="upload-icon">
                <svg-icon
                  [title]="'Upload file'"
                  src="/assets/icon/icon-upload.svg"
                  class="icon s-12"
                  aria-label="Upload"></svg-icon>
              </div>
              <div class="wrapper">
                <p class="text s-14 fw-600 green">
                  Click to upload
                  <span class="text s-14 fw-400">or drag and drop</span>
                </p>
                <p class="text s-12 fw-400">PDF or DOC files only</p>
              </div>
            </button>
          </nz-upload>

          <div class="ant-form-item-explain-error mt-3">
            <ng-container
              *ngIf="materialForm.get('attachment')?.touched && message">
              {{ message }}
            </ng-container>
          </div>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div class="drawer-footer">
      <button type="button" nz-button nzType="default" (click)="onCancel()">
        Cancel
      </button>
      <button
        type="submit"
        nz-button
        nzType="primary"
        [disabled]="materialForm.invalid">
        Save
      </button>
    </div>
  </form>
  <ng-template #iconTemplate let-file>
    <svg-icon
      src="/assets/icon/icon-report-green.svg"
      class="icon s-12"
      aria-label="Report Green"></svg-icon>
  </ng-template>
</nz-spin>
